import { render, staticRenderFns } from "./Prize.vue?vue&type=template&id=598a5ea2&scoped=true&"
import script from "./Prize.vue?vue&type=script&lang=js&"
export * from "./Prize.vue?vue&type=script&lang=js&"
import style0 from "./Prize.vue?vue&type=style&index=0&id=598a5ea2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "598a5ea2",
  null
  
)

export default component.exports